import { render, staticRenderFns } from "./OrmResult.vue?vue&type=template&id=1cfee086&scoped=true"
import script from "./OrmResult.vue?vue&type=script&lang=js"
export * from "./OrmResult.vue?vue&type=script&lang=js"
import style0 from "./OrmResult.vue?vue&type=style&index=0&id=1cfee086&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfee086",
  null
  
)

export default component.exports